"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

require("core-js/modules/es.regexp.exec");

require("core-js/modules/es.string.replace");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.url = exports.type = exports.isLocalType = exports.isLowerType = exports.isQedOrProdType = exports.isProdType = exports.isLocalEnv = exports.isProdEnv = exports.domainCountryCodePtn = exports.hostname = void 0;
var hostname = window.location.hostname.toLowerCase();
exports.hostname = hostname;
var domainCountryCodePtn = /\.([a-z]+)$/;
exports.domainCountryCodePtn = domainCountryCodePtn;
var isProdEnv = !/^(ci|demo|qed|localhost|\d+|lab\d*|qa\d*|sat\d*)\b/.test(hostname);
exports.isProdEnv = isProdEnv;
var isLowerEnv = /^(ci|demo|qed|lab\d*|qa\d*|sat\d*)\b/.test(hostname);
var isLocalEnv = /^(localhost|0\.0\.0\.0|127\.0\.0\.1)$/.test(hostname);
exports.isLocalEnv = isLocalEnv;
var lowerEnv = hostname.replace(/^(ci|demo|qed|lab\d*|qa\d*|sat\d*)\..*/, '$1').toUpperCase();
var envType = isProdEnv ? 'PROD' : isLowerEnv ? lowerEnv : isLocalEnv ? 'LOCAL' : 'UNKNOWN';
var isQedOrProd = /(PROD|SAT|QED)/.test(envType);
var isProdType = isProdEnv;
exports.isProdType = isProdType;
var isQedOrProdType = isQedOrProd;
exports.isQedOrProdType = isQedOrProdType;
var isLowerType = isLowerEnv;
exports.isLowerType = isLowerType;
var isLocalType = isLocalEnv;
exports.isLocalType = isLocalType;
var type = envType;
exports.type = type;
var url = '/api/security/v2/environments';
exports.url = url;
